import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    userId:null,
    profile:null,
  }

  export const userSlice=createSlice({
     name:'user',
     initialState,
     reducers:{
        setUserId:(state, action)=>{
           state.userId=action.payload
        },
        setProfile:(state, action)=>{
            state.profile=action.payload
        }
     }
  })
  export const {setUserId,setProfile}=userSlice.actions;
  export default userSlice.reducer